import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import KioskEntry from './KioskEntry';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><KioskEntry /></React.StrictMode>);
